import React from "react";

function HowItWorks(props) {
  return (
    <div>
      <section>
        <div className="how-it-works">
          <h2>how it works</h2>
          <div>
            <h3>Register</h3>
            <p>
              Create your personalized Cbastudyapp account by providing basic
              information and selecting your academic interests.
            </p>
          </div>
          <div>
            <h3>Explore </h3>
            <p>
              Discover our diverse range of courses, books, and study materials.
              Filter by category or search for specific topics of interest.
            </p>
          </div>
          <div>
            <h3>read and take notes </h3>
            <p>
              Read & Take Notes: Access your chosen resources and dive into an
              interactive reading experience using our intuitive interface. Take
              notes, highlight key points, and organize your study materials
              efficiently.
            </p>
          </div>
          <div>
            <h3>Download & Prepare </h3>
            <p>
              Download supplementary materials, such as lecture slides and
              practice tests, to enhance your understanding and preparation.
            </p>
          </div>
          <div>
            <h3>Assignment Help </h3>
            <p>
              Find comprehensive solutions to guide you through challenging
              assignments and exercises, empowering you to excel academically.
            </p>
          </div>
          <div>
            <h3>Engage & Learn</h3>
            <p>
              Participate in interactive quizzes and practice tests to reinforce
              your knowledge. Engage with the Cbastudyapp community and learn
              collaboratively.
            </p>
          </div>
          <div>
            <h3>Track Progress </h3>
            <p>
              Utilize ourprogress tracking tools to monitor your academic
              journey. Leverage insights and analytics to optimize your study
              strategies.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HowItWorks;
